import { AxiosResponse } from "axios";
import get from "lodash-es/get";

import api from "app/api/requests/Auth";
import { ISignUpRequest } from "app/api/types";

export const ADD_USER_PROFILE_REQUEST = "ADD_USER_PROFILE_REQUEST";
export const ADD_USER_PROFILE_SUCCESS = "ADD_USER_PROFILE_SUCCESS";
export const ADD_USER_PROFILE_FAIL = "ADD_USER_PROFILE_FAIL";

export const addUserProfile = (data: ISignUpRequest) => (
  dispatch: any
): any => {
  dispatch({ type: ADD_USER_PROFILE_REQUEST });

  return api
    .signUp(data)
    .then((response: AxiosResponse) => {
      dispatch({ type: ADD_USER_PROFILE_SUCCESS, payload: "" });
    })
    .catch(err => {
      dispatch({
        type: ADD_USER_PROFILE_FAIL
      });
      throw get(err, "response.data.errors", {});
    });
};
